<template>
  <div>
    <div v-if="clientId" ref="googleButton" class="google-button"></div>
    <button v-else type="button" class="google-fallback" disabled>
      {{ $t('google_signin_unavailable') }}
    </button>
  </div>
</template>

<script>
const GOOGLE_SCRIPT_ID = 'google-identity-services'

export default {
  name: 'GoogleLoginButton',
  props: {
    text: {
      type: String,
      default: 'signin_with'
    }
  },
  data() {
    return {
      clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID || ''
    }
  },
  mounted() {
    this.renderGoogleButton()
  },
  methods: {
    loadGoogleScript() {
      return new Promise((resolve, reject) => {
        if (window.google && window.google.accounts) {
          resolve()
          return
        }

        const existingScript = document.getElementById(GOOGLE_SCRIPT_ID)
        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true })
          existingScript.addEventListener('error', reject, { once: true })
          return
        }

        const script = document.createElement('script')
        script.id = GOOGLE_SCRIPT_ID
        script.src = 'https://accounts.google.com/gsi/client'
        script.async = true
        script.defer = true
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },

    async renderGoogleButton() {
      if (!this.clientId) return

      try {
        await this.loadGoogleScript()
        window.google.accounts.id.initialize({
          client_id: this.clientId,
          callback: this.handleCredentialResponse
        })
        const buttonWidth = Math.min(this.$el.clientWidth || 360, 360)
        window.google.accounts.id.renderButton(this.$refs.googleButton, {
          theme: 'outline',
          size: 'large',
          shape: 'rectangular',
          width: buttonWidth,
          text: this.text
        })
      } catch (error) {
        this.$emit('error', error)
      }
    },

    handleCredentialResponse(response) {
      if (!response || !response.credential) {
        this.$emit('error', new Error('Google authentication failed'))
        return
      }

      this.$emit('success', response.credential)
    }
  }
}
</script>

<style scoped>
.google-button {
  display: flex;
  justify-content: center;
  min-height: 40px;
}

.google-fallback {
  width: 100%;
  min-height: 42px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #f9fafb;
  color: #6b7280;
  font-weight: 600;
}
</style>
